module.exports = __webpack_public_path__ + "static/media/Photo1.07bd6e28.jpg";